import * as fromMenuActions from '../../actions/Componentes/menu.actions';

// tslint:disable-next-line: class-name
export interface menuState {
    accion: string;
    activo: boolean;
};

const initialStaterangosMP: menuState = {
    accion: '',
    activo: false
};

export function menuReducer(state = initialStaterangosMP, action: fromMenuActions.MenuActions): menuState {
    switch (action.type) {
        case fromMenuActions.MENU_VISIBLE:
            return {
                ...state,
                accion: 'Visible',
                activo: true
            };

        case fromMenuActions.MENU_HIDDEN:
            return {
                ...state,
                accion: 'Hidden',
                activo: false
            };
      default: {
        return state;
      }
    }
}